import {Pipe, PipeTransform} from '@angular/core';
import {CompetitorResultsDetail, Race} from '@model';
import {getCompetitorDistance} from "@utility";

@Pipe({
    name: 'competitorTempo',
    standalone: false
})
export class CompetitorTempoPipe implements PipeTransform {

  transform(competitorResultsDetail?: CompetitorResultsDetail, race?: Race, dropUnit?: boolean): string {
    if (!competitorResultsDetail || !race || (!competitorResultsDetail.tl_tm && !competitorResultsDetail.tl_ch_tm)) {
      return '-';
    }

    const timeString = competitorResultsDetail.tl_ch_tm || competitorResultsDetail.tl_tm;
    /// ignore milliseconds, they are not needed for this calculation
    const totalMinutes = this.convertToMinutes(timeString!.split('.')[0]);

    let distance = getCompetitorDistance(competitorResultsDetail, race)
    if (!distance) {
      return '-';
    }
    distance = distance / 1000;
    const tempo = totalMinutes / distance;
    return `${Math.floor(tempo)}:${this.padZero(Math.round((tempo % 1) * 60))}${dropUnit ? '' : ' min/km'}`;
  }

  private convertToMinutes(timeString: string): number {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return hours * 60 + minutes + seconds / 60;
  }

  private padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }
}
